let scrollbar = (hover = function () {}, outFromList = function () {}) => {
    return {
        range: 0,
        mousedown: 0,
        scrollable: 0,
        hover,
        outFromList,

        init(position = '') {
            this.$nextTick(() => {
                if (position === 'horizontal') {
                    this.scrollable = this.$refs.scrollable.scrollWidth - this.$refs.scrollable.clientWidth;

                    this.$watch('range', value => this.scrollTo(value, 0));

                    return;
                }

                this.scrollable = this.$refs.scrollable.scrollHeight - this.$refs.scrollable.clientHeight;

                this.$watch('range', value => this.scrollTo(0, value));
            });
        },

        increase(event) {
            if (event.which !== 1) {
                return;
            }

            this.mousedown = setInterval(() => {
                if (this.range < 100) {
                    this.range++;
                }
            }, 10);
        },

        decrease(event) {
            if (event.which !== 1) {
                return;
            }

            this.mousedown = setInterval(() => {
                if (this.range > 0) {
                    this.range--;
                }
            }, 10);
        },

        stop() {
            clearInterval(this.mousedown);
        },

        scrolled() {
            this.range = this.$refs.scrollable.scrollTop * 100 / this.scrollable;
        },

        scrollTo(x, y) {
            this.$refs.scrollable.scrollTo(this.scrollable * x / 100, this.scrollable * y / 100);
        }
    }
}
export default scrollbar;
